import React from 'react'
import bandeau from "../../../assets/bandeau.jpg";
export default function Header() {
    const [isHidden,setIsHidden]=React.useState(true);
    return (
        <>
        {isHidden ? (
            <div
             className="tester-header"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-around",
                  alignItems: "flex-start",
                  marginLeft: 20,
                }}
              >
                <span style={{ color: "white", fontWeight:'bold' }} onClick={() => setIsHidden(!isHidden)}>
                  Apprenez comment réaliser un test vidéo sur votre ordinateur
                </span>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#ffff",
                      width: 120,
                      height: 30,
                      borderRadius: 5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span style={{ color: "green" }}>Commencer</span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
            className="tester-header-reduced "
            >
              <div
                style={{ display: "flex", flexDirection: "row", paddingLeft: 20 }}
              >
                <div
                  style={{
                    height: 20,
                    width: 90,
                    borderRadius: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span
                    style={{ color: "white", fontSize: 12, fontWeight: "bold" }}
                  >
                    NOUVEAU !
                  </span>
                </div>
                <span style={{ color: "white", paddingLeft: 20 }}>
                  Apprenez comment réaliser un test vidéo sur votre ordinateur
                </span>
              </div>
              <div
                style={{
                  height: 30,
                  width: 90,
                  borderRadius: 2,
                  backgroundColor: "white",
                  marginRight: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => setIsHidden(!isHidden)}
              >
                <span
                  style={{ color: "purple", fontSize: 11, fontWeight: "lighter" }}
                >
                  Agrandir
                </span>
              </div>
            </div>
          )}
          </>
    )
} 
